import React, { useState, useEffect } from 'react';
import { getPedido, getTipoRetorno, postCreateTiket } from 'services/AyudaDinamicaServices';
import { useHistory } from 'react-router-dom';
import '../detallePedido/detallePedido.sass';
import './ayudaDinamica.sass';
import { useStorage64 } from 'hooks/useStorageBase64';
import { removeStorage } from 'functions/storageBase64';
import Loading from 'components/Loading';
import { useIsMobile } from 'hooks/useIsMobile';
import { ComoPrefieresDevolverDesktop } from 'pages/MiCuenta/MisPedidos/AyudaDinamica/AD-Desktop/vista37-comoPrefieresDevolver-desktop.js';
import { useToken } from 'hooks/useToken';
import { NO_IMAGE } from 'constants/general';
import { removeDuplicates } from 'functions/removeDuplicates';
import ModalPortal from 'components/Modal';
import { ModalError } from './vista4-modal';
import { repareTextHtml } from 'functions/repareDataService';

export function ComoPrefieresDevolverMovil() {
    const history = useHistory();
    const params = history.location.pathname;
    const separar = params.split('/');
    const idPedido = separar[3];
    const [idProductoEstate, setIdProductoEstate] = useState(0);
    const [resultadoPedido, setResultadoPedido] = useState(false);
    const [ima, setima] = useState([]);
    const [loading, setLoading] = useState(false);
    const [nombreProducto, setNombreProducto] = useState(false);
    const [opciones, setOpciones] = useState(false);
    const [listOpciones, setListOpciones] = useState(false);

    const [StorageOpcionDevolver, setStorageOpcionDevolver] = useStorage64('storageDevolverOpcion', '');
    const [peso_volumetrico, setPeso_volumetrico] = useState(false);
    // crear ticket
    const [showModalError, SetShowModalError] = useState(false); //mostrar modal error
    const [crearTicket, setCrearTicket] = useState(false);
    const [remover, setRemover] = useState(false); // activa loading cuando se comienza a crear el ticket
    const [infoTicketEntregado] = useStorage64("infoTicketEntregado");
    const [storageActionId] = useStorage64("storageActionId");
    const [storageMotivoEntregado] = useStorage64("storageMotivoEntregado");
    const [storageImgProducto] = useStorage64("storageImgProducto");
    const [storageDatosBancarios] = useStorage64("storageDatosBancarios");
    const [recoleccionDomicilio, setRecoleccionDomicilio] = useState("storageRecoleccionDomicilio", "");
    const [correoUsuario] = useStorage64('storageCorreoUsuario');
    const [storageReasonId] = useStorage64('storageIdProblem');
    const [shopId, setShopId] = useState(false);
    const [direccionPedido] = useStorage64('storageDireccionPedido');
    const [idTiendaFisica, setIdTiendaFisica] = useState(false);
    const [tipoGuia, setTipoGuia] = useState(false);
    const [idTicketStorage, setIdTicketStorage] = useStorage64('storageIdTicket');

    //MOSTRAR LOADING HASTA QUE SE CARGUE LA INFORMACION
    useEffect(() => {
        if ((opciones && opciones.TipoRetorno) && (resultadoPedido && resultadoPedido.pedido)) {
            setLoading(false);
        }
        else {
            setLoading(true);
        }
    }, [resultadoPedido, opciones])

    // revisa si tiene un id de producto
    useEffect(() => {
        let idProducto = 0;
        const urlParams = params.split('/');
        urlParams.shift();

        if (params.includes("/product=")) {
            for (let i = 0; i <= (urlParams.length - 1); i++) {
                if (urlParams[i].indexOf('product=') >= 0) {
                    idProducto = urlParams[i].replace('product=', '');
                }
            }
            setIdProductoEstate(idProducto);
        }
    }, [])

    // obtiene servicio pedido
    useEffect(() => {
        getPedido(idPedido)
            .then(setResultadoPedido);
    }, [])

    //------------------ INICIO PARA REFRESCAR TOKEN ---------------------------//
    const refreshCyR = useToken({ firstActive: false, name: "vista37- como prefieres devolver mobile" });
    const [tokenJWT, setTokenJWT] = useState(false);
    const [continuar, setContinuar] = useState(false);

    useEffect(() => {
        if (tokenJWT) {
            refreshCyR.forceToken(true);
            setTokenJWT(false);
        }
    }, [tokenJWT])

    useEffect(() => {
        if (refreshCyR.newToken) {
            setContinuar(true);
        }
    }, [refreshCyR.newToken])
    //------------------ FIN PARA REFRESCAR TOKEN ------------------------------//

    useEffect(() => {
        let imagenProducto = [];
        let productoNombre = [];
        let pesovolumetrico = [];
        let shopProducto = [];
        let arrayGuia = [];

        if (resultadoPedido) {
            if (resultadoPedido.pedido && resultadoPedido.status === 200) {
                // recorre por producto
                if (resultadoPedido.pedido && Number(idProductoEstate) !== 0) {
                    if (resultadoPedido.pedido[0]) {
                        resultadoPedido.pedido[0].products.map((elem, i) =>
                            Number(elem.related_product_id) === Number(idProductoEstate) && imagenProducto.push({ "url": elem.images[0]?.url, "id": elem?.related_product_id })
                        )
                        resultadoPedido.pedido[0].products.map((elem, i) =>
                            Number(elem.related_product_id) === Number(idProductoEstate) && productoNombre.push({ "nombre": elem.name })
                        )
                        resultadoPedido.pedido[0].products.map((elem, i) =>
                            Number(elem.related_product_id) === Number(idProductoEstate) && pesovolumetrico.push({ "peso_volumetrico": elem.dynamic_help?.return_by_volumetric_weight })
                        )

                        // guarda informacion sobre el vendedor del producto
                        resultadoPedido.pedido[0].products.map((elem, i) =>
                            Number(elem.related_product_id) === Number(idProductoEstate) && shopProducto.push({ "idTienda": elem.shop?.idTienda, "nameTienda": elem.shop?.name, "public_shop_id": elem.shop?.public_shop_id })
                        )
                        // guarda informacion sobre el tipo de guia
                        resultadoPedido.pedido[0].products.map((elem, i) =>
                            Number(elem.related_product_id) === Number(idProductoEstate) && arrayGuia.push({ "tipoGuia": elem.tracking?.guide_type })
                        )

                        let limpioImagen = removeDuplicates(imagenProducto, idProductoEstate);
                        setima(limpioImagen);
                        setNombreProducto(productoNombre);

                        setPeso_volumetrico(pesovolumetrico[0].peso_volumetrico);
                        setShopId(shopProducto[0].idTienda);
                        setIdTiendaFisica(shopProducto[0].public_shop_id);
                        setTipoGuia(arrayGuia[0].tipoGuia);
                    }
                }
            }
            else if (resultadoPedido.statusCode && resultadoPedido.statusCode === 401) {
                setTokenJWT(true);

                setTimeout(() => {
                    getPedido(idPedido)
                        .then(setResultadoPedido);
                }, 1000);
            }
        }
    }, [resultadoPedido])

    // obtengo list tipo de retorno
    useEffect(() => {
        getTipoRetorno()
            .then(setOpciones);
    }, [])

    // almaceno listado de action
    useEffect(() => {
        let arrayOpciones = [];

        if (opciones) {
            if (opciones.TipoRetorno && opciones.status === 200) {
                opciones.TipoRetorno.map((act, i) =>
                    arrayOpciones.push({ "id": act.id, "name": act.name, "order": act.order })
                )
                setListOpciones(arrayOpciones);
            }
            else if (opciones.statusCode && opciones.statusCode === 401) {
                setTokenJWT(true);

                setTimeout(() => {
                    getTipoRetorno()
                        .then(setOpciones);
                }, 1000);
            }
        }
    }, [opciones])

    // regresar a la pagina anterior
    const onClose = () => {
        history.goBack(-1);
    }

    // redirecciona a elegir tienda o genera el ticket
    const handleContinuarAseleccion = (id) => {

        setStorageOpcionDevolver(id);

        if (Number(id) === 1) {
            setRecoleccionDomicilio(1);
            history.push("/mi-cuenta/mis-pedidos/" + idPedido + "/product=" + idProductoEstate + "/elegir-tienda");
        }
        else if (Number(id) === 2) {
            if (peso_volumetrico === true) {
                setRecoleccionDomicilio(2);

                let client_id = infoTicketEntregado?.client_id;
                let order_id = infoTicketEntregado?.order_id;
                let order_number = infoTicketEntregado?.order_number;
                let ticket_type_id = infoTicketEntregado?.ticket_type_id;
                let action_id = storageActionId;
                let reason_id = infoTicketEntregado?.reason_id;
                let description = storageMotivoEntregado;
                let refound_details;

                if (storageDatosBancarios) {
                    refound_details = storageDatosBancarios;
                } else {
                    refound_details = [];
                }

                let products_to_cancel = [{ "id": idProductoEstate, "return_type": id, "subsidiary_id": idTiendaFisica }];
                let additional_details = storageImgProducto;
                let correo = correoUsuario;

                setRemover(true); // activa loading

                postCreateTiket({
                    reason_id,
                    order_id,
                    order_number,
                    client_id,
                    description,
                    products_to_cancel,
                    ticket_type_id,
                    refound_details,
                    additional_details,
                    action_id,
                    correo
                })
                    .then(setCrearTicket);
            }
        }
    }

    // si la respuesta es ticket creado === 201 redirecciona a thank you page de ticket creado
    useEffect(() => {
        if (crearTicket) {
            if (crearTicket.metadata) {
                if (Number(crearTicket.metadata.http_status) === 201) {

                    if (idProductoEstate !== 0) {
                        setIdTicketStorage(crearTicket.data.id);
                        // es reason 9 y action: 8 ó 9
                        // es reason 9 y action 1, 2, 3, 4
                        if ((storageReasonId === 9 && storageActionId === 8) || (storageReasonId === 9 && storageActionId === 9) ||
                            (storageReasonId === 9 && (storageActionId === 1 || storageActionId === 2 || storageActionId === 3 || storageActionId === 4))) {
                            //es guia automatica
                            if (tipoGuia === 2) {
                                history.replace("/mi-cuenta/mis-pedidos/" + idPedido + "/product=" + idProductoEstate + "/typ");
                            }
                            //no es guia automatica
                            else {
                                history.replace("/mi-cuenta/mis-pedidos/" + idPedido + "/product=" + idProductoEstate + "/seller-typ");
                            }

                        }
                    }
                }
                else {
                    history.replace("/mi-cuenta/mis-pedidos/" + idPedido + "/cancelacion-exitosa");
                }
            }
            else {
                SetShowModalError(true);
            }
        }
    }, [crearTicket])

    // mostrar el loading mientras se crea el ticket
    useEffect(() => {
        if (remover) {
            if (crearTicket) {
                setLoading(false);
                setRemover(false);
            }
            else {
                setLoading(true);
            }
        }
    }, [remover, crearTicket])

    // regresar a pedido en modal error
    const regresarPedidos = () => {
        SetShowModalError(false);
        history.replace("/mi-cuenta/mis-pedidos/dias=30/pagina=1");
    }
    // cerrar modal de error
    const handleCloseError = () => SetShowModalError(false);

    return (
        <>
            {loading && <Loading />}

            <div className="modalDetallePedido full">
                <div className="contentModal">

                    <div className="contentClose">
                        <div className="btn close" onClick={onClose} ></div>
                        <p className="title">¿Cómo prefieres devolver tu producto?</p>
                    </div>

                    <div className="dataModal">

                        <div className='headerImagenesTitulo'>
                            <div className="contenedorImagenesIgual1">
                                <ul className='ulIgual1'>
                                    {ima && ima.map((elemento, i) =>
                                        <li key={i}>
                                            <img src={elemento.url ? elemento.url : NO_IMAGE} alt={"imagen" + i} width={100} />
                                        </li>
                                    )}
                                </ul>
                            </div>

                            {ima && ima.length > 1
                                ? <div className='tituloImagenes'>
                                    <p>¿Qué quieres hacer?</p>
                                </div>
                                : <div className='tituloImagenes'><p>{nombreProducto && repareTextHtml(nombreProducto[0].nombre)}</p></div>
                            }
                        </div>

                        <div className="boxUlRazones">
                            <ul className="">
                                {listOpciones && listOpciones.map((problem) =>
                                    <li id={problem.id} key={problem.id} onClick={() => handleContinuarAseleccion(problem.id)}>
                                        <span className="nombreRazon">{problem.name}</span>
                                        <span className="iconoRazon"></span>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>

                    {showModalError &&
                        <ModalPortal type="modalSB" onClose={handleCloseError} >
                            <ModalError okRegresar={regresarPedidos} />
                        </ModalPortal>
                    }
                </div>
            </div>
        </>
    )
}

export function ComoPrefieresDevolver(props) {
    const { isMobile } = useIsMobile();

    return (
        <>
            {isMobile
                ? isMobile === 'desktop'
                    ? <ComoPrefieresDevolverDesktop />
                    : isMobile === 'movile'
                        ? null
                        : <ComoPrefieresDevolverMovil />
                : null
            }
        </>
    )
}